var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 34.643V5.357C8 4.608 8.624 4 9.393 4h12.179L32 14.16v20.483c0 .749-.624 1.357-1.393 1.357H9.393C8.624 36 8 35.392 8 34.643z",
    fill: "#4054B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.574 4 10.428 10.16h-9.035c-.769 0-1.393-.608-1.393-1.357V4z",
    fill: "#7E8ED9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.094 31.734h.875V29.81h1.32c1.106 0 1.871-.754 1.871-1.856v-.008c0-1.105-.765-1.847-1.87-1.847h-2.196v5.636zm1.976-4.898c.758 0 1.2.41 1.2 1.113v.008c0 .707-.442 1.117-1.2 1.117H12.97v-2.238h1.101zm3.22 4.898h.85v-4.093h.063l2.895 4.093h.789v-5.636h-.852v4.101h-.058l-2.899-4.101h-.789v5.636zm8.39.137c1.476 0 2.433-.926 2.433-2.355v-.7h-2.312v.707h1.449v.125c-.008.868-.637 1.45-1.559 1.45-1.058 0-1.722-.836-1.722-2.184v-.008c0-1.328.66-2.172 1.703-2.172.773 0 1.312.375 1.515 1.043l.012.04h.875l-.008-.04c-.203-1.09-1.113-1.816-2.394-1.816-1.578 0-2.598 1.16-2.598 2.95v.007c0 1.813 1.008 2.953 2.606 2.953z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.e926f95232b270bf853b42fe833a585a.svg";
export { ForwardRef as ReactComponent };